import { property, State } from '@common/lit/store/index.js';
import { PurposeType } from '@common/types/enum.js';
import type { Purpose } from '@common/types/model.js';

export const DEFAULT_MSISDN_FILTER = 'Alle MSISDN'; // nonbreakable space! #532

export class ConsentStore extends State {
  [key: string | symbol]: unknown;

  // the initial consents
  @property({ value: [] }) initialConsents!: Purpose[];

  // the consent state
  @property({ value: [] }) actualConsents!: Purpose[];

  // The MSISDN chosen by filtering
  @property({ value: DEFAULT_MSISDN_FILTER }) chosenMsisdn!: string;

  // Compare actual and initial consents to detect changes
  hasConsentChange() : boolean {
    // Only if both values have been set...
    if (this.initialConsents.length > 0 && this.actualConsents.length > 0) {
      return JSON.stringify(this.initialConsents) !== JSON.stringify(this.actualConsents);
    }
    return false;
  }

  hasAnyGrantedConsents(listOfPurposes : Purpose[] = this.actualConsents) {
    const anyIdentifierBoundGranted = listOfPurposes
      .filter((p) => p.purposeType === PurposeType.identifier_bound)
      .some((purpose) => purpose.subscriptions!
        .some((subscription) => subscription.apps
          .some((app) => app.granted)));

    const anyUserBoundGranted = listOfPurposes
      .filter((p) => p.purposeType === PurposeType.user_bound)
      .some((purpose) => purpose.apps!.some((app) => app.granted));

    return anyIdentifierBoundGranted || anyUserBoundGranted;
  }

  hasAnyGrantedConsentsForPurposeId(purposeId : string) {
    return this.hasAnyGrantedConsents(this.actualConsents.filter((purpose) => purpose.purposeId === purposeId));
  }
}

export const store = new ConsentStore();
